// Focus treatments for the Studio onboarding flow, matching the Figma states.
//
// Input focus:
//  - Active (pointer/click): subtle darker border (#C9CBCD), no halo.
//  - Focused (keyboard Tab): neutral border + info-primary (#0C41BB / `link`)
export const STUDIO_INPUT_FOCUS_CLASS = [
  '[&_.MuiOutlinedInput-root.Mui-focused:not(.Mui-error)_.MuiOutlinedInput-notchedOutline]:!border',
  '[&_.MuiOutlinedInput-root.Mui-focused:not(.Mui-error)_.MuiOutlinedInput-notchedOutline]:!border-[#c9cbcd]',
  '[html[data-studio-keyboard]_&_.MuiOutlinedInput-root.Mui-focused:not(.Mui-error)_.MuiOutlinedInput-notchedOutline]:!border-non-hover-border',
  '[html[data-studio-keyboard]_&_.MuiOutlinedInput-root.Mui-focused:not(.Mui-error)]:!outline',
  '[html[data-studio-keyboard]_&_.MuiOutlinedInput-root.Mui-focused:not(.Mui-error)]:!outline-[1.5px]',
  '[html[data-studio-keyboard]_&_.MuiOutlinedInput-root.Mui-focused:not(.Mui-error)]:!outline-link',
  '[html[data-studio-keyboard]_&_.MuiOutlinedInput-root.Mui-focused:not(.Mui-error)]:!outline-offset-2',
].join(' ');

// Buttons (Google secondary + studio primary) use a text-primary
// (#212B36 / `black-heading`) halo offset 1px outside the button.
export const STUDIO_BUTTON_FOCUS_CLASS = [
  'focus:!outline',
  'focus:!outline-[1.5px]',
  'focus:!outline-offset-1',
  'focus:!outline-black-heading',
].join(' ');

// Studio primary CTA button: the Figma label is 16px regular, but the
// design-system button renders its label as a nested medium 14px <p>, so the
// size/weight are overridden on that element. Includes the focus halo.
export const STUDIO_PRIMARY_BUTTON_CLASS = [
  '[&_p]:font-normal',
  '[&_p]:text-lg',
  STUDIO_BUTTON_FOCUS_CLASS,
].join(' ');
